import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarSegmentosDs,
  criarLogradouroDs,
} from "../../DataSources";
import ShowError from "../../AppServices";

let _segmentoCorrente;

const template = {
  id: undefined,
  prefeituraId: undefined,
  logradouroId: undefined,
  codigo: undefined,
  precoM2Terreno: undefined,
  descricao: "",
  larguraDaVia: undefined,
  comprimentoTrecho: undefined,
  cep: "",
  setorPar: "",
  quadraPar: "",
  facePar: "",
  setorImpar: "",
  quadraImpar: "",
  faceImpar: "",
  numeroInicialPar: "",
  placaDeIdentificacaoPar: true,
  guiaESargetaPar: true,
  qtdeBocaDeLoboPar: undefined,
  numeroFinalPar: "",
  numeroInicialImpar: "",
  placaDeIdentificacaoImpar: true,
  guiaESargetaImpar: true,
  qtdeBocaDeLoboImpar: undefined,
  numeroFinalImpar: "",
  placaDeIdentificacaoCentral: true,
  guiaESargetaCentral: true,
  qtdeBocaDeLoboCentral: undefined,
  pavimentacao: true,
  energiaEletrica: true,
  redeSanitaria: true,
  coletaDeLixo: true,
  sentidoTrafego: undefined,
  iluminacaoPublica: undefined,
  redeDeAgua: true,
  redeTelefonica: true,
  galeriasPluviais: true,
  varricao: true,
};

export default class SegmentosForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    template.prefeituraId = UserInfo.getPrefeitura();
    this.segmentosDs = criarSegmentosDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.segmentosDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data == undefined) {
            notify("Segmento não encontrado.", "error");
            this.props.history.push("/segmentos");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    const tipoPavimentacao = [
      { id: "0", descricao: "Não Informado" },
      { id: "1", descricao: "Sem Pavimentação" },
      { id: "2", descricao: "Asfalto" },
      { id: "3", descricao: "Paralelepípedo" },
      { id: "4", descricao: "Pedra Tosca" },
      { id: "5", descricao: "Pré-Moldado" },
      { id: "6", descricao: "Piçarra" },
    ];

    const tipoSentidoTrafego = [
      { id: "0", descricao: "Não Informado" },
      { id: "1", descricao: "Dois Sentidos" },
      { id: "2", descricao: "Crescente" },
      { id: "3", descricao: "Decrescente" },
    ];

    const tipoIluminacaoPublica = [
      { id: "0", descricao: "Não Informado" },
      { id: "1", descricao: "Sem Iluminação" },
      { id: "2", descricao: "Incandescente" },
      { id: "3", descricao: "Vapor de Mercúrio" },
      { id: "4", descricao: "Vapor de Sódio" },
      { id: "5", descricao: "Lâmpadas LED" },
    ];

    const escolherLogradouro = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarLogradouroDs(),
      valueExpr: "id",
      displayExpr: "nomeCompleto",
    };

    const escolherPavimentacao = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: tipoPavimentacao,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    const escolherSentidoTrafego = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: tipoSentidoTrafego,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    const escolherIluminacaoPublica = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: tipoIluminacaoPublica,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={3}>
            <GroupItem
              caption="INFORMAÇÕES DE SEGMENTO"
              colSpan={3}
              colCount={3}
            >
              <SimpleItem
                dataField={"logradouroId"}
                editorType={"dxLookup"}
                editorOptions={escolherLogradouro}
              >
                <Label text="Logradouro" />
              </SimpleItem>
              <SimpleItem dataField={"codigo"}>
                <Label text="Cod. do Segmento" />
              </SimpleItem>
              <SimpleItem dataField={"precoM2Terreno"}>
                <Label text="Vl.M² do Terreno" />
              </SimpleItem>
            </GroupItem>
            <GroupItem colCount={1} colSpan={3}>
              <SimpleItem dataField={"descricao"} editorType={"dxTextArea"}>
                <Label text="Descrição" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="DADOS GERAIS" colSpan={3} colCount={3}>
              <SimpleItem dataField={"larguraDaVia"}>
                <Label text="Largura da Via" />
              </SimpleItem>
              <SimpleItem dataField={"comprimentoTrecho"}>
                <Label text="Comprimento do Trecho" />
              </SimpleItem>
              <SimpleItem dataField={"cep"}>
                <Label text="Cep" />
              </SimpleItem>
            </GroupItem>
            <GroupItem colCount={2} colSpan={3}>
              <GroupItem caption="QUADRA PAR" colSpan={1} colCount={1}>
                <SimpleItem dataField={"setorPar"}>
                  <Label text="Setor" />
                </SimpleItem>
                <SimpleItem dataField={"quadraPar"}>
                  <Label text="Quadra" />
                </SimpleItem>
                <SimpleItem dataField={"facePar"}>
                  <Label text="Face" />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption="QUADRA ÍMPAR" colSpan={1} colCount={1}>
                <SimpleItem dataField={"setorImpar"}>
                  <Label text="Setor" />
                </SimpleItem>
                <SimpleItem dataField={"quadraImpar"}>
                  <Label text="Quadra" />
                </SimpleItem>
                <SimpleItem dataField={"faceImpar"}>
                  <Label text="Face" />
                </SimpleItem>
              </GroupItem>
            </GroupItem>
            <GroupItem caption="LADO PAR" colSpan={1} colCount={1}>
              <SimpleItem
                dataField={"placaDeIdentificacaoPar"}
                editorType={"dxCheckBox"}
              >
                <Label text="Placa de Identificação" />
              </SimpleItem>
              <SimpleItem
                dataField={"guiaESargetaPar"}
                editorType={"dxCheckBox"}
              >
                <Label text="Guia e Sarjeta" />
              </SimpleItem>
              <SimpleItem dataField={"qtdeBocaDeLoboPar"}>
                <Label text="Qtde. Boca de Lobo" />
              </SimpleItem>
              <SimpleItem dataField={"numeroInicialPar"}>
                <Label text="Nº Inicial" />
              </SimpleItem>
              <SimpleItem dataField={"numeroFinalPar"}>
                <Label text="Nº Final" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="LADO ÍMPAR" colSpan={1} colCount={1}>
              <SimpleItem
                dataField={"placaDeIdentificacaoImpar"}
                editorType={"dxCheckBox"}
              >
                <Label text="Placa de Identificação" />
              </SimpleItem>
              <SimpleItem
                dataField={"guiaESargetaImpar"}
                editorType={"dxCheckBox"}
              >
                <Label text="Guia e Sarjeta" />
              </SimpleItem>
              <SimpleItem dataField={"qtdeBocaDeLoboImpar"}>
                <Label text="Qtde. Boca de Lobo" />
              </SimpleItem>
              <SimpleItem dataField={"numeroInicialImpar"}>
                <Label text="Nº Inicial" />
              </SimpleItem>
              <SimpleItem dataField={"numeroFinalImpar"}>
                <Label text="Nº Final" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="CANTEIRO CENTRAL" colSpan={1} colCount={1}>
              <SimpleItem
                dataField={"placaDeIdentificacaoCentral"}
                editorType={"dxCheckBox"}
              >
                <Label text="Placa de Identificação" />
              </SimpleItem>
              <SimpleItem
                dataField={"guiaESargetaCentral"}
                editorType={"dxCheckBox"}
              >
                <Label text="Guia e Sarjeta" />
              </SimpleItem>
              <SimpleItem dataField={"qtdeBocaDeLoboCentral"}>
                <Label text="Qtde. Boca de Lobo" />
              </SimpleItem>
            </GroupItem>
            <GroupItem
              caption="FATORES CORRETIVOS DO TERRENO"
              colSpan={3}
              colCount={4}
            >
              <SimpleItem
                dataField={"pavimentacao"}
                editorType={"dxLookup"}
                editorOptions={escolherPavimentacao}
              >
                <Label text="Pavimentação" />
              </SimpleItem>
              <SimpleItem
                dataField={"energiaEletrica"}
                editorType={"dxCheckBox"}
              >
                <Label text="Energia Elétrica" />
              </SimpleItem>
              <SimpleItem
                dataField={"redeTelefonica"}
                editorType={"dxCheckBox"}
              >
                <Label text="Rede Telefonica" />
              </SimpleItem>
              <SimpleItem dataField={"varricao"} editorType={"dxCheckBox"}>
                <Label text="Varrição" />
              </SimpleItem>
              <SimpleItem
                dataField={"sentidoTrafego"}
                editorType={"dxLookup"}
                editorOptions={escolherSentidoTrafego}
              >
                <Label text="Sentido Tráfego" />
              </SimpleItem>
              <SimpleItem
                dataField={"galeriasPluviais"}
                editorType={"dxCheckBox"}
              >
                <Label text="Galerias Pluviais" />
              </SimpleItem>
              <SimpleItem dataField={"redeDeAgua"} editorType={"dxCheckBox"}>
                <Label text="Rede de Água" />
              </SimpleItem>
              <SimpleItem dataField={"redeSanitaria"} editorType={"dxCheckBox"}>
                <Label text="Rede Sanitária" />
              </SimpleItem>
              <SimpleItem
                dataField={"iluminacaoPublica"}
                editorType={"dxLookup"}
                editorOptions={escolherIluminacaoPublica}
              >
                <Label text="Iluminação Pública" />
              </SimpleItem>
              <SimpleItem dataField={"coletaDeLixo"} editorType={"dxCheckBox"}>
                <Label text="Coleta de Lixo" />
              </SimpleItem>
            </GroupItem>
            <GroupItem colCount={2} colSpan={3}>
              <ButtonItem
                buttonOptions={{
                  width: 100,  
                  type: "success",
                  text: "Salvar",
                  onClick: this.ok,
                }}
              />
              <ButtonItem
                alignment='left'
                buttonOptions={{
                  width: 100,
                  type: "warn",
                  text: "Cancelar",
                  onClick: this.cancel,
                }}
              />
            </GroupItem>
          </Form>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = this.state;
    inserirOuAtualizar(this.segmentosDs, entidade)
      .then(
        function () {
          _segmentoCorrente = undefined;
          notify("Segmento cadastrado com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _segmentoCorrente = undefined;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
